// External
import { useState } from "react";

// Local
import RunButton from "./RunButton"
import AllTestCases from "./AllTestCases";

// CSS
import "./RunTests.css"


export default function RunTests({selectedLanguage}){

    const [judge0_API_Response_JSON, set_judge0_API_Response_JSON] = useState({});
    const [is_loading, set_is_loading] = useState(false);
    const [problem_accepted, set_problem_accepted] = useState("Await Response");

    return(
        <div className="run-tests-container">

                {!is_loading && 
                    <div className="status-runbutton-wrapper">


                        <div className="submission-status">
                            {problem_accepted === "Accepted" && <div className="submission-status-accepted"> Accepted</div>}
                            {problem_accepted === "Failed" && <div className="submission-status-failed"> Failed </div>}
                            {problem_accepted === "Failed-Hidden-Test" && 
                                <div className="submission-status-failed-hidden">
                                    Failed Hidden Test
                                    <button className="add-hidden-testcase-button">
                                        +
                                    </button>
                                </div>
                            }
                        </div>

                            <RunButton 
                                setJudge0APIResponseJSON={set_judge0_API_Response_JSON}
                                isLoading={is_loading}
                                setIsLoading = {set_is_loading}
                                selectedLanguage = {selectedLanguage}
                                problemAccepted = {problem_accepted}
                            />

                        </div>

                }
               

                     
              


            {is_loading ? 
            <section className="sec">
               <div className="loader">
                    {Array.from({ length: 20 }, (_, idx) => (
                        <span
                            key={idx}
                            style={{ '--i': idx-20 }}
                            className="spn"
                        />
                    ))}
                </div>
            </section>
                :
                <AllTestCases judge0APIResponseJSON={judge0_API_Response_JSON} setProblemAccepted={set_problem_accepted}/> 
            }
        </div>

    );
  
}